<template>
	<div
		class="subscribe_doctor_time_list"
		ref="listPatient"
		:class="{
			'shrink': !showAll && shrink,
			'fill': !showHandle
		}"
	>
		<div ref="listChildBox">
			<van-row class="van_row" :gutter="7" v-for="(item, index) in options" :key="`van-row-${ index }`">
				<van-col :span="8" v-for="(val,index) in item" :key="`van-col-${index}`">
					<p
						class="date_text"
						:class="{
							hide: !val.startTime,
							disabled: val.startTime && !val.canAppointment,
							active: index === modelValue
						}"
						@click="clickDateItem(val,index)"
					>
						{{ val.startTime | timeFilter }}-{{ val.endTime | timeFilter }}
					</p>
				</van-col>
			</van-row>

			<div v-if="showHandle">
				<div class="handle"></div>
				<div class="handle foot" @click="clickToggle">
					<img class="icon" src="@/assets/icon/icon_arrow_default.png" alt="" />
					<span class="text">{{ shrink ? '查看全部时段' : '收起' }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'subscribe_doctor_time_list',
    data: () => ({
        shrink: true,
        unShrinkPatientHeight: ''
    }),
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        // 列表
        list: {
            type: Array,
            default: () => []
        },
        // 每行显示数量
        colNum: {
            type: [String, Number],
            default: 3
        },
        // 是否显示全部
        showAll: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        timeFilter (val) {
            if (!val) return ''
            return val.substring(val.indexOf(' ') + 1, val.lastIndexOf(':'))
        }
    },
    computed: {
        modelValue: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        },
        options () {
            const list = this.list
            if (list.length % this.colNum) {
                list.push({})
                // const _list = list.reduce((val, item) => {
                // 	const lastIndex = val.length - 1
                // 	console.log(val,lastIndex,val[lastIndex])
                // 	if (val[lastIndex].length === 3) {
                // 		val.push([item])
                // 	} else {
                // 		val[lastIndex].push(item)
                // 	}
                // 	return val
                // }, [])

                // while(_list[_list.length - 1].length < this.colNum) {
                // 	_list[_list.length - 1].push([])
                // }
                // return _list
            }
            return [this.list]
        },
        showHandle () {
            if (this.showAll) return false
            return this.list.length > this.colNum * 3
        }
    },
    methods: {
        clickDateItem ({ canAppointment }, index) {
            if (canAppointment) this.modelValue = index
        },
        clickToggle () {
            if (this.shrink) {
                this.unShrinkPatientHeight = this.$refs.listPatient.style.maxHeight
                this.$refs.listPatient.style.maxHeight = this.$refs.listChildBox.offsetHeight + 32 + 'px'
                this.shrink = false
            } else {
                this.$refs.listPatient.style.maxHeight = this.unShrinkPatientHeight
                this.shrink = true
            }
        }
    }
};
</script>

<style scoped lang="less">
.subscribe_doctor_time_list {
	overflow: hidden;
	transition: all 0.3s;
	position: relative;
	&.shrink {
		max-height: 340px;
	}
	&.fill::after {
		content: '';
		display: block;
		height: 32px;
	}
	.van_row {
		& + .van_row {
			margin-top: 15px;
		}
		.date_text {
			box-sizing: border-box;
			height: 68px;
			line-height: 68px;
			border-radius: 6px;
			text-align: center;
			font-family: PingFangSC-Regular;
			font-size: 26px;
			font-weight: normal;
			color: #1f2329;
			background-color: #f5f6f7;
			transition: all 0.2s;
			border: 2px solid #f5f6f7;
			margin-bottom: 16px;
			&.active {
				color: @primary;
				border-color: @primary;
				background-color: mix(#fff, @primary, 90%);
			}
			&.disabled {
				opacity: 0.4;
			}
		}
	}
	.handle {
		width: 100%;
		height: 98px;
		box-sizing: border-box;
		background-color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 32px 0;
		&.foot {
			position: absolute;
			bottom: 0;
			left: 0;
		}
		.icon {
			width: 12px;
			vertical-align: middle;
			transform: rotate(-90deg);
			margin-right: 13px;
			transition: all 0.2s;
		}
		.text {
			font-family: PingFangSC-Regular;
			font-size: 24px;
			font-weight: normal;
			color: #8f959e;
		}
	}
	&.shrink {
		.handle {
			.icon {
				transform: rotate(90deg);
			}
		}
	}
}
</style>
